import React from "react";
import { useTranslation } from "react-i18next";
import {
  InfoBox,
  InfoList,
  UpfrontPaymentDesktopContainer,
  UpfrontPaymentFieldRow,
  UpfrontPaymentFieldRowTitle,
} from "./UpfrontPayment.styles";
import { BillingSupportNumber } from "./types";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import UpfrontPaymentPhoneLink from "./UpfrontPaymentPhoneLink";

export const OA100NoPaymentRequired: React.FC = () => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();

  return (
    <UpfrontPaymentDesktopContainer deviceType={deviceType}>
      <UpfrontPaymentFieldRow adjustable>
        <UpfrontPaymentFieldRowTitle data-testid="oa100-header">
          {t("upfrontPayment.oa100.additionalResponsibility")}
        </UpfrontPaymentFieldRowTitle>
        <div
          style={{
            color: "#5D5A5A",
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "uppercase",
            wordWrap: "break-word",
            textAlign: "center",
            margin: "24px 0px",
          }}
        >
          {t("upfrontPayment.oa100.noAdditionalResponsibility")}
        </div>
        <InfoBox>
          <InfoList>
            <li>{t("upfrontPayment.oa100.noDirectPayments")}</li>
            <br />
            <li>
              {t("upfrontPayment.oa100.questionsPrefix")}
              <UpfrontPaymentPhoneLink />
              {t("upfrontPayment.oa100.questionsSuffix")}
            </li>
          </InfoList>
        </InfoBox>
      </UpfrontPaymentFieldRow>
    </UpfrontPaymentDesktopContainer>
  );
};
